// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"ce4cd524","165":"de5a58d8","453":"fd2f0c4a","796":"9b3331d5"}[chunkId] + ".chunk.js";
};